import API from "../../../../../global/api";


export const requestAddDayOpening = () => {
    return {
        type: "REQUEST_ADD_DAY_OPENING",
    };
};
export const successAddDayOpening = (data) => {
    return {
        type: "SUCCESS_ADD_DAY_OPENING",
        payload: data,
    };
};
export const errorAddDayOpening = () => {
    return {
        type: "ERROR_ADD_DAY_OPENING",
    };
};
export const addDayOpening = (data, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddDayOpening());
        API.post(`/dayOpen/add_day_open`, data).then((res) => {
            dispatch(successAddDayOpening(data));
            showSuccessAlert(res.data.message);
        }).catch((error) => {
            dispatch(errorAddDayOpening());
            showErrorAlert(error.response.data.message);
        })
    };
};


export const requestGetDayOpening = () => {
    return {
        type: "REQUEST_GET_DAY_OPENING",
    };
};
export const successGetDayOpening = (data) => {
    return {
        type: "SUCCESS_GET_DAY_OPENING",
        payload: data,
    };
};
export const errorGetDayOpening = () => {
    return {
        type: "ERROR_GET_DAY_OPENING",
    };
};
export const getDayOpening = () => {
    return (dispatch) => {
        dispatch(requestGetDayOpening());
        API.get(`/dayOpen/get_day_open`).then((res) => {
            let data = res.data;
            dispatch(successGetDayOpening(data));
        }).catch((error) => {
            dispatch(errorGetDayOpening());
        })
    };
};


export const requestAddDayClosing = () => {
    return {
        type: "REQUEST_ADD_DAY_CLOSING",
    };
};
export const successAddDayClosing = (data) => {
    return {
        type: "SUCCESS_ADD_DAY_CLOSING",
        payload: data,
    };
};
export const errorAddDayClosing = () => {
    return {
        type: "ERROR_ADD_DAY_CLOSING",
    };
};
export const addDayClosing = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddDayClosing());
        API.post(`/dayOpen/closing_day`, data).then((res) => {
            dispatch(successAddDayClosing(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddDayClosing());
            handleDangerVisible(error.response.data.message);
        })
    };
};